export enum NotificationMessageTypeEnums {
  NEW,
  REPLY,
  REPLY_ALL,
  FORWARD,
}
